import React, { useEffect, useState } from 'react';
import {
  GridFooter,
  GridFooterContainer,
} from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { LeagueType, useLeagueContext } from '../../contexts/LeagueContext';
import { fetchLatestCompletedGame } from '../../../api/api';

export default function LastUpdated() {
    const leagueContext: any = useLeagueContext();
    const league: LeagueType = leagueContext?.selectedLeague?.toLowerCase() || 'nba';

    const [ lastUpdated, setLastUpdated ] = useState<string | null>(null);

    useEffect(() => {
        fetchLatestCompletedGame(league)
        .then((response) => {
            setLastUpdated(response.date);
        })
        .catch(() => {
            setLastUpdated(null);
        });
    }, [ league ]);

    return (
      <GridFooterContainer>
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', paddingLeft: 2 }}>
          <Typography variant="body2" color="textSecondary">
            { lastUpdated && `Includes games through ${lastUpdated}` }
          </Typography>
        </Box>
        <GridFooter />
      </GridFooterContainer>
    );
  }
